// extracted by mini-css-extract-plugin
export default {"title":"RoomDetails_title__Cv0uF","edit":"RoomDetails_edit__X4Byd","cancel":"RoomDetails_cancel__Nwg6j"};